import React from 'react';

export const IconLoaderDotsHorizontal = ({ width, height, color }) => {

  const styles = {
    frame: {
      display: 'inline-block',
      width,
      height
    },
    container: {
      display: 'inline-block',
    },
    svg: {
      width: '100%'
    }
  }

  return (
    <div style={styles.frame}>
      <div style={styles.container} className="menu-button-icon-bubbles">
        <svg className="if loader dots horizontal" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" style={styles.svg}>
          <g className="if svg g">
            <circle
              className="if svg circle"
              fill={color || '#331e11'}
              cx="8"
              cy="32"
              r="8"
            />
            <circle
              className="if svg circle"
              fill={color || '#331e11'}
              cx="32"
              cy="32"
              r="8"
            />
            <circle
              className="if svg circle"
              fill={color || '#331e11'}
              cx="56"
              cy="32"
              r="8"
            />
          </g>
        </svg>
      </div>
    </div>
  )
};